export default __webpack_public_path__ + "static/media/GPA_Banner_StartStopService.18a7d94d.png";